export const toggleFilterMenu = () => {
    const filterMenu = document.querySelector('.js-filter-menu');
    filterMenu.classList.toggle('active');
    const filterMenuOverlay = document.querySelector('.js-filter-menu-overlay');
    filterMenuOverlay.classList.toggle('is-active');

    const body = document.querySelector('body#recipes');
    body.classList.toggle('modal-open');
}

export const closeFilterMenu = (setApplyFilters) => {
    const filterMenu = document.querySelector('.js-filter-menu');
    filterMenu.classList.remove('active');
    const filterMenuOverlay = document.querySelector('.js-filter-menu-overlay');
    filterMenuOverlay.classList.remove('is-active');

    const body = document.querySelector('body#recipes');
    body.classList.remove('modal-open');

    // Disable the "Apply Filters" button
    setApplyFilters(true);

    const filterAccordions = document.querySelectorAll('.b-recipes-advanced-filter__checkbox-wrapper');
    for (let i=0; i< filterAccordions.length; i+=1) {
        filterAccordions[i].classList.remove('active');
    }

    const input = document.getElementById('filter-menu-search');
    input.value = "";
}
